import { Pipe, PipeTransform } from '@angular/core';
import { MemberAccount } from '../../../models/transactions/member-account';

@Pipe({
  name: 'isExhaustedAccount'
})
export class IsExhaustedAccountPipe implements PipeTransform {
  transform(account: MemberAccount): boolean {
    return account.isExhausted();
  }
}
